import { DateTimeViewer, EnumViewer, GetDefaultIndexWithCollect } from "../../components";
import { useGetGlanceAdjustmentCommonInfoQuery, useCollectGlanceAdjustmentsMutation } from "../../features/board/glanceApi";
import { useGlanceAdjustmentRoutes } from "./routes";
import { GlanceAdjustmentCollector } from "./glanceAdjustmentCollector";
import { GlanceAdjustmentCommonInfoModel } from "../../entities/glance";
import { Col, Descriptions, Row } from "antd";
import { GlanceAdjustmentTypeEnum } from "../../entities/enums";

export { useGlanceAdjustmentRoutes };

export default GetDefaultIndexWithCollect({
  title: "نگاه‌های تعدیل",
  query: useGetGlanceAdjustmentCommonInfoQuery,
  collectMutation: useCollectGlanceAdjustmentsMutation,
  collector: (collectCallback) => <GlanceAdjustmentCollector collectCallback={collectCallback} />,
  generalInfoPresentor: (info: GlanceAdjustmentCommonInfoModel) =>
    info ? (
      <Row>
        {info.adjustmentTypeInfos?.map((x) => (
          <Col xs={24} lg={12} xxl={8} key={x.adjustmentType}>
            <Descriptions
              size="small"
              column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
              title={
                <span className="text-sm text-gray-500">
                  <EnumViewer type={GlanceAdjustmentTypeEnum} value={x.adjustmentType} />
                </span>
              }>
              <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
                {x.totalRecords}
              </Descriptions.Item>
              <Descriptions.Item label="آخرین کالکت" labelStyle={{ color: "gray" }}>
                <DateTimeViewer value={x.lastCollectedRecord} mode="distance" />
              </Descriptions.Item>
            </Descriptions>
          </Col>
        ))}
      </Row>
    ) : null,
});
